// extracted by mini-css-extract-plugin
export default {"inputWrapper":"BasicInput_inputWrapper__bugv4","label":"BasicInput_label__2GqRh","required":"BasicInput_required__4c3J1","input":"BasicInput_input__uXlOi"};